import { Row, Col, Card, CardBody, Button } from "reactstrap";
import React from "react";
import { FIELDS } from "./CONSTANT";
import { FieldInput } from "../../../components/FieldInput";
import { usePagination } from "../../../hooks/usePagination";
import { getAdmins } from "../../../api/admins";

export default function InternalPayslipeForm({ validation }) {
  const { response } = usePagination(getAdmins);

  function handleChooseAllAdmins() {
    validation.setFieldValue(
      "admins",
      (response.data.data || response.data)["admins"].map((c) => {
        return c.id;
      })
    );
  }

  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <Row>
              {FIELDS.map((f) => (
                <FieldInput key={f.key} f={f} validation={validation} />
              ))}
            </Row>
            <div className="d-flex" style={{ justifyContent: "flex-end" }}>
              <Button color="dark" onClick={handleChooseAllAdmins}>
                Select All Admins
              </Button>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
